import { useListSkillsQuery } from '@graphql/generated';

export const useSkills = () => {
  const { data: skillsData, loading } = useListSkillsQuery();
  const { listSkills: skills } = skillsData || { listSkills: [] };
  return { skills, loading };
};
